import S from "common/service/sanctuary";
import React, { Fragment } from "react";
import { compose } from "ramda";
import { connect } from "react-redux";
import { func, string, bool } from "prop-types";
import {
  FormattedMessage,
  defineMessages,
  intlShape,
  injectIntl,
} from "react-intl";
import Button from "common/mdc/button";
import Dialog from "common/mdc/dialog";
import { ResourceWrapper } from "common/mdc/wrappers";
import Form, { Error, DisplayField } from "common/mdc/form/index";
import TextField from "common/mdc/textfield/index";
import { namespace } from "d3";
import { selectors, actions } from "@sma/store/tag/tags";
import { validateLabel, validateNamespace, validateDescription } from "./validator";

class CreateNewTag extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      label: "",
      nameSpace: "",
      description: "",
      uiError: null,
      isEditSaveDisabled: true
    };

    this.handleCreateOrEditTag = this.handleCreateOrEditTag.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const { id, label, namespace, description } = this.props.tagInfo;
    const { isEdit, isAttachTag, attachLabel } = this.props;
    if(isEdit && id !== undefined && label !== undefined && namespace !== undefined && description !== undefined){
      this.setState({
        id: id,
        label: label,
        nameSpace: namespace,
        description: description,
      });
    }
    if(isAttachTag){
      this.setState({label: attachLabel});
    }
  }

  handleCreateOrEditTag() {
    const { id, label, nameSpace, description } = this.state;
    const { isEdit, isFromSearch, isAttachTag, limit } = this.props;
    const isSubmit=true;
    const isInValidLabel = validateLabel(label, isSubmit);
    if(isInValidLabel){
      this.setState({
        uiError: isInValidLabel,
      });
      return;
    }
    const isInValidNamespace = validateNamespace(nameSpace, isSubmit);
    if(isInValidNamespace){
      this.setState({
        uiError: isInValidNamespace,
      });
      return;
    }
    const isInValidDescription = validateDescription(description, isSubmit);
    if(isInValidDescription){
      this.setState({
        uiError: isInValidDescription,
      });
      return;
    }
    if (
      label.length >= 3 &&
      label.length <= 50 &&
      nameSpace.length <= 50 &&
      description.length >= 10 &&
      description.length <= 250
    ) {
      this.setState({
        uiError: null,
      });
      const tagObj = {
        label,
        namespace: nameSpace === "" ? "user" : nameSpace,
        description,
      };
      if(isEdit){
        this.props.editTag(id, tagObj);
      }
      else{
        this.props.createTag(tagObj, isAttachTag, limit);
        isAttachTag ? null : this.props.handleCreateCallback();
      }
      if(!isFromSearch || !isEdit || isAttachTag){
        this.props.clearSearch();
      }
      if(this.props.isAttachTag){
        this.props.handleNewTagCreateFromAttach(tagObj);
      }
    }
  }

  handleChange(inputFor, text) {
    const { isEdit } = this.props;
    this.setState({ [inputFor]: text }, () => {
      const { label, nameSpace, description } = this.state;
      const isInValidLabel = validateLabel(label, isEdit);
      if(isInValidLabel){
        this.setState({
          uiError: isInValidLabel,
          isEditSaveDisabled: true
        });
        return;
      }
      const isInValidNamespace = validateNamespace(nameSpace, isEdit);
        if(isInValidNamespace){
        this.setState({
          uiError: isInValidNamespace,
          isEditSaveDisabled: true
        });
        return;
      }
      const isInValidDescription = validateDescription(description, isEdit);
      if(isInValidDescription){
        this.setState({
          uiError: isInValidDescription,
          isEditSaveDisabled: true
        });
        return;
      }
      this.setState({
        uiError: null,
      });
      if (
        label.length >= 3 &&
        label.length <= 50 &&
        nameSpace.length <= 50 &&
        description.length >= 10 &&
        description.length <= 250
      ) {
        this.setState({
          uiError: null,
          isEditSaveDisabled: false
        });
      }
    });
  }

  render() {
    const {
      showCreateTagDialog,
      apiError,
      pending,
      onClose,
      onClick,
      isEdit,
      isAttachTag,
    } = this.props;
    const { uiError, isEditSaveDisabled } = this.state;

    const buttons = (
      <Fragment>
        <Button onClick={()=>showCreateTagDialog(false)} className="mdc-dialog__footer__button">
          cancel
        </Button>
        <Button
          raised
          onClick={
            () => this.handleCreateOrEditTag(onClose)
          }
          className="mdc-dialog__footer__button"
          disabled = { isEdit && isEditSaveDisabled }
        >
          {isEdit ? "save" : "create tag"}
        </Button>
      </Fragment>
    );

    return (
      <Dialog
        title={isEdit ? "Edit Tag" : "Create Tag"}
        onClose={onClose}
        buttons={buttons}
        loading={pending}
        onClick={onClick}
      >
        <div className="create-tag-content">
          <Form>
            {uiError && <Error>{uiError}</Error>}
            {apiError && <Error>{apiError}</Error>}
            <DisplayField label={"Label"} isRequired>
              <TextField
                type="text"
                onChange={(e) => this.handleChange("label", e.target.value)}
                fullWidth
                value={this.state.label}
              />
            </DisplayField>
            <DisplayField label={"Namespace"}>
              <TextField
                type="text"
                fullWidth
                onChange={(e) => this.handleChange("nameSpace", e.target.value)}
                value={this.state.nameSpace}
                placeholder="user"
              />
            </DisplayField>
            <DisplayField label={"Description"} isRequired>
              <TextField
                type="text"
                fullWidth
                onChange={(e) =>
                  this.handleChange("description", e.target.value)
                }
                value={this.state.description}
              />
            </DisplayField>
          </Form>
        </div>
      </Dialog>
    );
  }
}

CreateNewTag.defaultProps = {
  tagInfo: {
    id: undefined,
    label: undefined,
    namespace: undefined,
    description: undefined,
  },
  isEdit: false,
  isFromSearch: false,
  isAttachTag: false,
};

export default compose(
  connect(
    (state) => ({
      //state
      pending: state.tags.createTag.pending,
      apiError: state.tags.createTag.error,
    }),
    {
      //actions
      createTag: actions.create,
      showCreateTagDialog: actions.showCreateTagDialog,
      editTag: actions.edit,
    }
  ),
  injectIntl
)(CreateNewTag);
